<template lang="pug">
.flex.flex-col.gap-6
  h1.unicorn-h1.mt-4 Заявка восстановления

  .flex.flex-col.gap-4(class="md:flex-row md:items-center md:justify-between")
    .flex(class="flex-col md:flex-row md:items-center")
      | Выбор даты
      u-date-picker(
        class="md:ml-4 md:mt-0"
        v-model="date"
        :min-date="firstDate"
        :max-date="maxDate"
        title-position="left"
        :model-config="modelConfig"
      )
        template(v-slot="{ inputValue, inputEvents }")
          u-button(block v-on="inputEvents") {{ inputValue ? `${inputValue}` : "Выбор даты" }}
    
  .flex.items-center.gap-2(v-if="date && learners.length > 0")
    u-switch.mobile-switch(
      @change="toggleAllCouponsImmediate"
      :modelValue="allCouponsSelected"
      :variant="allCouponsSelected ? 'success' : 'primary'"
      :icon="allCouponsSelected ? 'mdi-checkbox-multiple-marked' : 'mdi-checkbox-multiple-blank-outline'"
      :label="allCouponsSelected ? 'Снять всё' : 'Выбрать всё'" 
      style="order: 2;"
    )

  u-alert(variant="danger" icon="mdi-alert")
    template(#title) Внимание!
    p Эта страница используется ТОЛЬКО для созданния заявок восстановления!
    p Не используйте ее для создания заявок на текущий день!
    p.mt-2.font-medium Заявки восстановления могут быть созданы только для текущего месяца!

  Request.border-red-400(
    v-if="date"
    ref="requestComponent"
    :learners="learners"
    :date="date"
    @close-request="closeRequestConfirm"
    @request-sent="handleRequestSent"
  )

  u-dialog(persistent width="360" v-model="confirm")
    template
      u-card
        u-card-title Отправка заявки
        u-card-body
          u-alert(variant="danger") Внимание! Это действие нельзя отменить после подтверждения
          p.mt-4.font-medium Вы отправляете заявку в столовую:
          table.mt-2
            tr(v-for="entry in waitingRequest.stats", :key="entry.id")
              td {{ entry.name }}
              td: span.ml-2.text-red-600 {{ entry.count }} шт.
        u-card-actions
          u-spacer
          u-button.mr-2(@click="confirm = false" variant="secondary" text) Отмена
          u-button(@click="closeRequest" variant="danger") Продолжить

  offline(v-if="offlineError", @close="offlineError = false")
</template>

<script>
import { sortBy } from "lodash";
import Api from "../services/Api";
import Offline from "@/app/shared/components/Offline";

export default {
  components: { Offline },

  data() {
    return {
      learners: [],
      request: {},
      foodSets: [],
      socialGroups: [],

      offlineError: false,

      confirm: false,
      positionsCount: {},
      waitingRequest: { classId: null, positions: null, date: null },

      date: "",

      currentDate: "",
      firstDate: "",
      lastDate: "",

      allCouponsSelected: false,

      modelConfig: {
        type: "string",
        mask: "YYYY-MM-DD"
      }
    };
  },

  computed: {
    currentMonth() {
      return new Date(this.currentDate).getMonth();
    },

    maxDate() {
      return this.currentMonth === 11 || this.currentMonth === 4
        ? this.lastDate
        : this.currentDate;
    }
  },

  watch: {
    async date() {
      const { classId } = this.$route.params;
      await this.loadEntrants(classId, this.date);
      this.resetAllToggles();
    }
  },

  async mounted() {
    await this.loadServerTime();
    await this.startAutoUpdate();
  },

  beforeDestroy() {
    this.stopAutoUpdate();
  },

  methods: {
    async startAutoUpdate() {
      const { classId } = this.$route.params;
      await this.stopAutoUpdate();
      this.autoUpdateId = setInterval(() => {
        this.getServerTime(classId);
      }, 5000);
    },

    async stopAutoUpdate() {
      clearInterval(this.autoUpdateId);
    },

    async getServerTime() {
      await Api.time();
    },

    async loadServerTime() {
      const { data: timestamp } = await Api.time();
      const date = new Date(timestamp);

      const day = date.getDate();
      const month = date.getMonth();
      const year = date.getFullYear();

      this.currentDate = this.formatDate(day - 1, month, year);
      this.firstDate = this.formatDate(1, month, year);
      this.lastDate = this.formatDate(0, month + 1, year);
    },

    formatDate(day, month, year) {
      return new Date(year, month, day)
        .toLocaleDateString()
        .split(".")
        .reverse()
        .join("-");
    },

    async loadEntrants(classId, date) {
      const { data: learners } = await Api.classes.getClassLearners(
        classId,
        date
      );
      this.learners = sortBy(learners, ["surname", "name"]);
    },

    toggleAllCouponsImmediate() {
      this.allCouponsSelected = !this.allCouponsSelected;

      requestAnimationFrame(() => {
        if (this.$refs.requestComponent) {
          this.$refs.requestComponent.toggleAllCoupons(this.allCouponsSelected);
        }
      });
    },

    resetAllToggles() {
      this.allCouponsSelected = false;

      if (this.$refs.requestComponent) {
        this.$refs.requestComponent.resetAllSelections();
      }
    },

    handleRequestSent() {
      this.resetAllToggles();
    },

    async closeRequestConfirm(req) {
      this.confirm = true;
      this.waitingRequest = req;
    },

    async closeRequest() {
      const { classId, body } = this.waitingRequest;

      try {
        await Api.requests.closeRequest(classId, body, this.date);
        await this.loadEntrants(classId, this.date);
        this.resetAllToggles();
      } catch (error) {
        const { status } = (error && error.response) || { status: error };
        alert(this.getRequestCloseErrorDesc(status));
      } finally {
        this.confirm = false;
      }

      this.waitingRequest = { classId: null, body: null };
    },

    getRequestCloseErrorDesc(httpErrorCode) {
      switch (httpErrorCode) {
        case 402:
          return "Недостаточно средств. Попробуйте обновить сраницу (клавиша F5)";
        case 404:
          return "Заявка не найдена. Попробуйте перезагрузить страницу (клавиша F5)";
        case 422:
          return "Ошибка в 'Своем заказе'";
        case 409:
          return "Повторное оформление заявки";
        case 500:
          return "Ошибка сервера. Попробуйте позднее";
        case 502:
          return "Тех. работы на сервере. Попробуйте через 5 минут";
        default:
          this.offlineError = true;
          return "Неопознанная ошибка: " + httpErrorCode;
      }
    }
  }
};
</script>

<style scoped>
.switches-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  min-height: 40px;
}

.mobile-switch,
.desktop-switch {
  isolation: isolate;
  position: relative !important;
  z-index: 0 !important;
  transition: none !important;
}

.mobile-switch >>> *,
.desktop-switch >>> * {
  z-index: 0 !important;
  transition: none !important;
}

.mobile-switch >>> .v-input__icon,
.mobile-switch >>> .mdi,
.mobile-switch >>> i,
.mobile-switch >>> .v-icon,
.mobile-switch >>> svg,
.desktop-switch >>> .v-input__icon,
.desktop-switch >>> .mdi,
.desktop-switch >>> i,
.desktop-switch >>> .v-icon,
.desktop-switch >>> svg {
  z-index: 0 !important;
  position: relative !important;
  transition: none !important;
}

@media (max-width: 767px) {
  .mobile-switch {
    display: inline-flex !important;
    align-items: center !important;
    vertical-align: middle !important;
    flex-shrink: 0;
  }

  .mobile-switch >>> .v-input,
  .mobile-switch >>> .v-input__control,
  .mobile-switch >>> .v-input__slot {
    min-height: 40px !important;
    transition: none !important;
  }
}
</style>
